<template>
  <footer class="application-footer">
    <div class="application-footer__wrapper">
      <div class="application-footer__container">
        <a :href="clientLink" target="_blank" class="application-footer-logo">
          <picture>
            <source id="s3" :srcset="logoSrcDefault" type="image/svg">
            <img :src="logoSrc" alt="" onerror="this.src=document.getElementById('s3').srcset;">
          </picture>
        </a>
        <a v-if="!$store.state.isWidget" :href="technologyLink" class="application-footer-logo-ldp">
          <div class="application-footer-logo-ldp__container">
            <img
              :src="isSnsEnabled ? 'static/img/thankdigit_tech_logo-dark.svg' : 'static/img/ldp-logo_lion-dark.svg'"
              :alt="isSnsEnabled ? 'thank.Digit' : 'Lions Digital Pro'"
              class="application-footer-logo-ldp__image"
            />
            <div class="application-footer-logo-ldp__text-container">
              <div class="application-footer-logo-ldp__text">
                {{ isSnsEnabled ? $t('login.work_tech') : $t('login.work_tech') }}
              </div>
              <img
                :src="isSnsEnabled ? 'static/img/sns-logo_text-dark.svg' : 'static/img/ldp-logo_text-dark.svg'"
                :alt="isSnsEnabled ? 'thank.Digit' : 'Lions Digital Pro'"
                class="application-footer-logo-ldp__name"
              />
            </div>
          </div>
        </a>
        <div
          v-if="policyHref"
          class="application-footer-link"
        >
          <a
            :href="policyHref"
            class="application-footer-link__link"
            target="_blank"
          >
            {{ $t('labels.privacy_policy') }}
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
  import config from '@/config'
  import {CONF_CLIENT_SITE_LINK, CONF_CLEINT_LOGO_PREFIX, LANG, PRIVACY_POLICY, CONF_USE_SNS, CONF_TECHNOLOGY_LINK} from '@/constants'
  import {getCheckedLang} from '@/services/langStorage'

  export default {
    data () {
      return {
        clientLink: config(CONF_CLIENT_SITE_LINK),
        clientLogoPrefix: config(CONF_CLEINT_LOGO_PREFIX)
      }
    },
    computed: {
      isSnsEnabled() {
        return config(CONF_USE_SNS) !== false;
      },
      technologyLink() {
        return config(CONF_TECHNOLOGY_LINK) || 'https://lionsdigital.pro';
      },
      policyHref () {
        return config(PRIVACY_POLICY) || '';
      },
      lang () {
        return getCheckedLang() || config(LANG) || 'en'
      },
      logoSrc () {
        return `static/img/logos/${this.clientLogoPrefix}_grey_new_${this.lang}.svg`;
      },
      logoSrcDefault () {
        return `static/img/logos/${this.clientLogoPrefix}_grey_new_en.svg`;
      }
    }
  }

</script>
<style lang="scss">
</style>